// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ju9p","header":"PatientQuestionnaire_header__13RKB","info":"PatientQuestionnaire_info__2eB_e"};